// extracted by mini-css-extract-plugin
export var container = "GiftingBlock-module__container___KxLyG";
export var content = "GiftingBlock-module__content___gh7fA";
export var image = "GiftingBlock-module__image___BkTHk";
export var imageContainer = "GiftingBlock-module__imageContainer___dwEpP";
export var subText = "GiftingBlock-module__subText___UtPT1";
export var title = "GiftingBlock-module__title___N2TJZ";